import api from './api'

const API = '/api/client/rescheduled-tickets'

export const RescheduledTicket = {
  get: function(params) {
    return api.get(API, {params: params})
  },
  show: function(id, params) {
    return api.get(API + '/' + id, params)
  },
  create: function(params) {
    return api.create(API, params)
  },
  update: function(id, form) {
    return api.update(API+'/'+id, form)
  },
  delete: function(params) {
    return api.delete(API+'/'+params.id, params)
  }
}
